import React, { Component } from 'react'
import { Switch, withRouter, Route } from 'react-router-dom'

import Mission from 'Containers/Mission'
import { PrivateRoute } from 'Config/Routing/auth'
import { PATHS } from 'Config/Routing/paths'

class MissionRouter extends Component {
  render() {
    return (
      <Switch>
        <Route
          exact
          path={`${this.props.match.url}${PATHS.mission.rosterMissionView}`}
        >
          <PrivateRoute>
            <Mission />
          </PrivateRoute>
        </Route>
        <Route path={`${this.props.match.url}${PATHS.mission.missionEdit}`}>
          <PrivateRoute>
            <Mission {...this.props} editMode />
          </PrivateRoute>
        </Route>
        <Route
          path={`${this.props.match.url}${PATHS.mission.rosterMissionEdit}`}
        >
          <PrivateRoute>
            <Mission {...this.props} editMode />
          </PrivateRoute>
        </Route>
      </Switch>
    )
  }
}

export default withRouter(MissionRouter)



// WEBPACK FOOTER //
// ./src/Config/Routing/MissionRouter.js